/**
 * The 24h/72h width control, shared by every surface that has one.
 *
 * The markup is identical wherever it appears — a `role="group"` of pressed
 * buttons — so it lives once. Only the label, the widths offered, and what
 * selecting one does differ between surfaces.
 */
export function SearchWindowToggle<Hours extends number>({
  label, options, selected, onSelect, disabled = false, optionLabel = (hours) => `${hours}h`,
}: {
  label: string;
  options: readonly Hours[];
  selected: number;
  onSelect: (hours: Hours) => void;
  disabled?: boolean;
  /** How each width reads; defaults to "24h". */
  optionLabel?: (hours: Hours) => string;
}) {
  return (
    <div className="search-window-toggle" role="group" aria-label={label}>
      {options.map((hours) => (
        <button
          key={hours}
          type="button"
          className={selected === hours ? 'active' : ''}
          aria-pressed={selected === hours}
          disabled={disabled}
          onClick={() => onSelect(hours)}
        >
          {optionLabel(hours)}
        </button>
      ))}
    </div>
  );
}
